import React, { useState } from 'react';
import dayjs from 'dayjs';
import { CalendarIcon } from 'lucide-react';
import { Input } from 'components/shadcn/ui/input';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from 'components/shadcn/ui/popover';
import { DayPicker } from 'components/shadcn/ui/date-picker/DayPicker';
import { MonthPicker } from 'components/shadcn/ui/date-picker/MonthPicker';
import { YearPicker } from 'components/shadcn/ui/date-picker/YearPicker';

const DateSearchInput = ({
    value,
    onSearchChange,
    placeholder = 'Search date...',
}) => {
    const [open, setOpen] = useState(false);
    const [view, setView] = useState('day');
    const [selectedDate, setSelectedDate] = useState(dayjs());

    const handleOpenChange = (isOpen) => {
        if (!isOpen) setView('day');
        setOpen(isOpen);
    };

    const handleDaySelect = (date) => {
        setSelectedDate(date);
        setOpen(false);
        onSearchChange(date.format('M/D/YYYY'));
    };

    const handleMonthSelect = (date) => {
        setSelectedDate(date);
        setView('day');
        onSearchChange(date.format('M/YYYY'));
    };

    const handleYearSelect = (date) => {
        setSelectedDate(date);
        setView('month');
        onSearchChange(date.format('YYYY'));
    };

    return (
        <div className="relative flex w-full items-center">
            <Popover open={open} onOpenChange={handleOpenChange}>
                <PopoverTrigger asChild>
                    <button
                        className="absolute left-0 flex h-full w-9 items-center justify-center border-r border-border text-muted-foreground hover:text-foreground"
                        aria-label="Pick a date"
                    >
                        <CalendarIcon className="h-4 w-4" />
                    </button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    {view === 'day' && (
                        <DayPicker
                            selectedDate={selectedDate}
                            onSelect={handleDaySelect}
                            maxDate={null}
                            onLabelClick={() => setView('month')}
                        />
                    )}
                    {view === 'month' && (
                        <MonthPicker
                            selectedDate={selectedDate}
                            onSelect={handleMonthSelect}
                            maxDate={null}
                            onLabelClick={() => setView('year')}
                        />
                    )}
                    {view === 'year' && (
                        <YearPicker
                            selectedDate={selectedDate}
                            onSelect={handleYearSelect}
                            maxDate={null}
                        />
                    )}
                </PopoverContent>
            </Popover>
            <Input
                placeholder={placeholder}
                value={value}
                className="w-full pl-11"
                onChange={({ currentTarget }) =>
                    onSearchChange(currentTarget.value)
                }
            />
        </div>
    );
};

export default DateSearchInput;
